var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataReady)?_c('div',[_c('b-card',{staticClass:"mt-4 mb-4 container",staticStyle:{"border":"1px solid","border-radius":"5px"},attrs:{"id":"print","bg-variant":"white","no-body":""}},[_c('form-10-layout',{attrs:{"result":_vm.result}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }